export const UPDATE_PROFILE_DETAILS_SETTINGS = 'UPDATE_PROFILE_DETAILS_SETTINGS';
export const UPDATE_PROFILE_DESCRIPTION = 'UPDATE_PROFILE_DESCRIPTION';
export const DELETE_ACCOUNT = 'DELETE_ACCOUNT';

export const AUTH_FACEBOOK_BY_CODE = 'AUTH_FACEBOOK_BY_CODE';
